/**
 * ITextMeasurer over MSDF font metrics (UI-3). Falls back to the monospace heuristic while a
 * style's font (and no default font) isn't registered — text still lays out, just approximately.
 */
import { UIMeasureMode } from '../layout/ILayoutEngine';
import { layoutText } from './layoutText';
import { resolveTextFont } from './MsdfFont';
import { MonospaceTextMeasurer, type ITextMeasurer, type UITextStyle } from './TextMeasurer';

export class MsdfTextMeasurer implements ITextMeasurer {
  private readonly fallback = new MonospaceTextMeasurer();

  measure(
    text: string,
    style: UITextStyle,
    availableWidth: number,
    widthMode: UIMeasureMode,
  ): { width: number; height: number } {
    const resolved = resolveTextFont(style);
    if (!resolved) return this.fallback.measure(text, style, availableWidth, widthMode);
    const maxWidth =
      widthMode === UIMeasureMode.Undefined || !Number.isFinite(availableWidth) || availableWidth <= 0
        ? Infinity
        : availableWidth;
    const layout = layoutText(resolved.font, text, {
      fontSize: style.fontSize,
      lineHeight: style.lineHeight,
      letterSpacing: style.letterSpacing,
      align: style.textAlign,
      maxWidth,
      wrap: style.whiteSpace !== 'nowrap',
      measureOnly: true,
    });
    return { width: layout.width, height: layout.height };
  }
}
